export default "__VITE_ASSET__BxJT4wn2__"